import { connect } from "react-redux";
import { default as component } from "./ProjectDetailsTable.jsx";

// UI Actions
import { activateModal } from "../../common/UI/ActiveModal/duck/actions";

// Local Selectors
import { getProjectDetails } from "../duck/selectors";

const mapStateToProps = state => {
  return {
    project: getProjectDetails(state)
  };
};

const mapDispatchToProps = {
  activateModal
};

export default connect(mapStateToProps, mapDispatchToProps)(component);
